import template from "./app.html";
import controller from "./app.controller";
import "../node_modules/bootstrap-sweetalert/dist/sweetalert.css"
import "../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "../node_modules/animate.css/animate.css";
import "../node_modules/bootstrap/less/bootstrap.less";
import "./less/style.less";
import "../node_modules/angular-toastr/dist/angular-toastr.css";
import "../node_modules/angular-xeditable/dist/css/xeditable.css";
import "../node_modules/angular-bootstrap-toggle/dist/angular-bootstrap-toggle.css";
import "../node_modules/awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css";
import "../node_modules/footable/css/footable.core.css";
import "../node_modules/chart.js/dist/Chart";
import "../node_modules/angular-chart.js/dist/angular-chart";
import "../node_modules/eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min";
import "../node_modules/datatables/media/css/jquery.dataTables.css";
import "../node_modules/angular-datatables/dist/css/angular-datatables.css";
import "../node_modules/datatables.net-buttons-bs4/css/buttons.bootstrap4.css";
import '../node_modules/dropzone/dist/dropzone.css'
import '../node_modules/ngdropzone/dist/ng-dropzone.min.css'

let appComponent = {
  template,
  controller,
  restrict: 'E'
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app.component.js